import { OnPremHostnameConfig } from '../interfaces/OnPremHostnameConfig';
import { OnPremHostnameDictionary } from '../interfaces/OnPremHostnameDictionary';

export default class OnPremHostnameConfiguration {
  private static config: OnPremHostnameConfig = {
    OnPremHostnameDictionary: OnPremHostnameConfiguration.GetOnPremHostnameDictionary(),
  };

  private static GetOnPremHostnameDictionary(): OnPremHostnameDictionary {
    const context: OnPremHostnameDictionary = {};

    context.client_0 = process.env.REACT_APP_CMS_IA_CLIENT_ONPREM_HOSTNAME;
    context.client_6 = process.env.REACT_APP_CMS_INVESTIA_CLIENT_ONPREM_HOSTNAME;
    context.advisor_0 = process.env.REACT_APP_CMS_IA_ADVISOR_ONPREM_HOSTNAME;
    context.advisor_6 = process.env.REACT_APP_CMS_INVESTIA_ADVISOR_ONPREM_HOSTNAME;
    context.client_14 = {};
    context.client_14.fr = process.env.REACT_APP_CMS_IAWEALTH_CLIENT_ONPREM_HOSTNAME_FR;
    context.client_14.en = process.env.REACT_APP_CMS_IAWEALTH_CLIENT_ONPREM_HOSTNAME_EN;
    context.dealer_0 = process.env.REACT_APP_CMS_IA_DEALER_ONPREM_HOSTNAME;
    context.partner_0 = process.env.REACT_APP_CMS_IA_PARTNER_ONPREM_HOSTNAME;

    return context;
  }

  public static Current(): OnPremHostnameConfig { return OnPremHostnameConfiguration.config; }
}
